var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingCountryData),expression:"loadingCountryData"}],attrs:{"element-loading-spinner":"qc-spinner","loading":_vm.loadingCountryData}},[_c('canvas',{attrs:{"id":"countryStatsGraph"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }